export default "__VITE_ASSET__CQbXRtUm__"